export default {
  beheardReport: {
    reportBeingGenerated: 'Your #BeHeard Report is being generated...',
    title: {
      report: '#BeHeard {type} Report',
      premium: 'Premium',
      free: 'Free',
    },
    shortTermQuestion:
      'The chances of leaving my job voluntarily during the next year are Extremely Low.',
    longTermQuestion:
      'I feel that I will have a long career at this organization.',
    sectionTitles: {
      overview: 'OVERVIEW',
      characteristics: 'CHARACTERISTICS',
      participation: 'PARTICIPATION',
      results: 'RESULTS',
      topFiveRecommendations: 'TOP 5 RECOMMENDATIONS',
      employeeTurnoverForecast: 'EMPLOYEE TURNOVER FORECAST',
      comparisonGraphs: 'COMPARISON GRAPHS',
      fullReport: 'FULL REPORT',
      customQuestions: 'CUSTOM QUESTIONS',
    },
    navigationTitles: {
      overview: 'Overview',
      characteristics: 'Characteristics',
      results: 'Results',
      topFiveRecommendations: 'Top 5 Recommendations',
      employeeTurnoverForecast: 'Turnover',
      comparisonGraphs: 'Comparison Graphs',
      fullReport: 'Full Report',
      customQuestions: 'Custom Questions',
    },
    overview: {
      overviewDescription:
        'Your #BeHeard Premium Report provides much more than an employee engagement score. It provides key findings about the extent your employees feel passionate about their jobs, are committed to your organization, put discretionary effort into their work and are willing to refer. That’s because employee engagement relates directly to productivity, revenue, absenteeism, turnover, customer satisfaction and other organization insights. In addition to your overall employee engagement score, this report provides results on five engagement drivers, forecasts short and long-term turnover, and offers customized recommendations for taking action to increase engagement.',
    },
    characteristics: {
      description:
        'Before you dive into the results, let’s start by looking at the key characteristics of engaged and disengaged employees. This is why taking action to build employee engagement matters!',
      engagedEmployees: { title: 'Engaged Employees' },
      disengagedEmployees: { title: 'Disengaged Employees' },
    },
    participation: {
      overallRate: 'Overall Rate',
      description:
        'Click on each demographic filter below to view specific participation rates.',
      noParticipation: 'Check back, no one has participated yet.',
      demographicsWithLessThanFiveParticipants:
        'Demographics that have less than 5 participants for a particular value will show N/A. (e.g., 4 participants in the IT Department will show N/A)',
    },
    results: {
      description:
        'This section provides a snapshot of your engagement results including the Top 5 Action Areas, the Top 5 Strengths, and the Top 5 Most Important Items to your employees.',
      engagementScore: { engagement: 'Engagement', score: 'Score' },
      engagementDriversHeader: 'Engagement Driver Scores',
      effectiveness: 'EFFECTIVENESS',
    },
    progressBarLegend: {
      legendTitle: 'Effectiveness Score Legend',
      colorMeaning: {
        negative: 'Unfavorable',
        neutral: 'Neutral',
        positive: 'Favorable',
      },
    },
    driverScore: {
      alignment:
        'The extent to which employees believe in and put effort toward this organization’s mission, values and goals.',
      engagement:
        'The extent to which employees feel passionate about their jobs, are committed to our organization, put discretionary effort into their work and are willing to refer.',
      fit: 'The extent to which employees feel they are in the right jobs and have the necessary skills, knowledge and abilities to adequately perform in their roles.',
      growth:
        'The extent to which employees feel supported to advance their career or develop personal skill sets within this organization.',
      team: 'The extent to which this organization promotes a team-based work style (i.e. departments or groups work well together).',
      valuing:
        'The extent to which employees feel valued by this organization.',
      custom_ratings_questions: 'Custom Ratings Questions',
    },
    topFiveText: {
      action: {
        title: 'Top 5 Action Areas',
        description:
          'Your employees ranked the following statements as low in effectiveness and high in importance (i.e. these items have the biggest ROI Gap). You will get the greatest return on investment if you focus your engagement efforts on these five areas (listed in order of priority).',
      },
      strength: {
        title: 'Top 5 Strengths',
        description:
          'Your employees ranked the following statements as high in effectiveness and high in importance (i.e. these items have the smallest ROI Gap). Use this data to promote your employee brand in talent attraction, engagement and retention strategies. These are your greatest strengths!',
      },
      importance: {
        title: 'Top 5 Most Important Items',
        description:
          'Your employees ranked the following five statements as the most important to them.',
      },
      topFiveResultDetails: {
        effectiveness: 'Effectiveness',
        importance: 'Importance',
        previousEffectiveness: 'Previous Effectiveness',
        benchmarkEffectiveness: 'Benchmark Effectiveness',
      },
      topFiveRecommendations: {
        description:
          'These actionable recommendations are based on your Top 5 Action Areas. This is where your efforts to boost engagement will give you the largest return on investment. Time to take action!',
        noRecommendations:
          'There are no Recommendations for the results displayed.',
      },
      tooltip: { roiGap: 'Difference between effectiveness and importance' },
    },
    filterButtons: { filters: 'Filters', download: 'Download' },
    downloadMenu: {
      pdfNewTab: 'Open in new tab (PDF)',
      pdfDownload: 'PDF',
      xlsxDownload: 'Spreadsheet (.xlsx)',
    },
    noData: 'There are no {title} for the results displayed.',
    turnoverOverviewDescription:
      'The likelihood employees will leave your organization within the next twelve months.',
    turnoverForecast: {
      statement: 'STATEMENT',
      atRisk: 'At Risk',
      passive: 'Passive',
      committed: 'Committed',
      employee: 'employee',
      employees: 'employees',
      potentialTurnover: 'Potential Turnover',
      previousTurnover: 'Previous Turnover',
      description:
        "Your short and long-term outlook is predicted using your employees' responses to the turnover statements in the survey.",
      shortTerm: 'Short-Term Outlook',
      longTerm: 'Long-Term Outlook',
    },
    comparisonGraphs: {
      description:
        'Now it’s time to take a closer look at engagement results across the organization. Simply hover over the bar charts to see specific results. Depending on your permission settings, you can use Filters to change the comparison graphs.',
      demographic: 'Demographic',
      legend: {
        engaged: 'Engaged',
        neutrals: 'Neutral',
        disengaged: 'Disengaged',
      },
    },
    fullReport: {
      engagementScore: 'Engagement Score',
      participationRate: 'Participation Rate',
      legend: {
        strengths: 'Strengths',
        recommendedActionAreas: 'Recommended Action Areas',
      },
      tableHeaders: {
        score: 'Score',
        result: 'Result',
        effectiveness: 'Effectiveness',
        importance: 'Importance',
        previousEffectiveness: 'Prev. Effec.',
        benchmark: 'Benchmark',
      },
      tableData: { viewRecommendations: 'View recommendations here' },
      openEndedQuestions: 'Open-Ended Questions',
      noCustomRatingQuestions:
        'No custom ratings questions were used in this survey.',
      noCustomOpenEndedQuestions:
        'No custom open-ended questions were used in this survey.',
      buttonLabels: {
        xlsx: 'Download answers as XLSX',
        pdf: 'Download answers as PDF',
      },
    },
    unlockPremiumReport: 'CLICK HERE TO UNLOCK THE PREMIUM REPORT',
    snackbar: {
      success: {
        surveyAddedToCart: 'Survey added to your cart successfully',
        filters: 'Your filters have been applied!',
      },
    },
  },
  report: {
    upgradeReport: 'Upgrade Report',
    freeReport: 'Free Report',
    premiumReport: 'Premium Report',
    shareReport: 'Share Report',
  },
  survey: {
    actions: {
      clone: 'Clone Survey',
      preview: 'Preview Survey',
      archive: 'Archive Survey',
    },
    status: {
      scheduled: 'Scheduled',
      open: 'Open',
      closed: 'Closed',
      awaitingManualOpening: 'Awaiting Manual Launch',
    },
    snackbar: {
      success: {
        alreadyFinished: 'You already finished this survey',
        finishedSurvey: 'You finished the survey! Thanks for taking the time',
        giftCardRedeemed:
          'Gift Card redeemed successfully! Watch for an email with your electronic gift card link.',
      },
    },
  },
  surveyKey: {
    status: {
      surveykey: 'Survey Key',
      paragraph1:
        'Kyselyssä käytetään kasvoja ja tähtiä luokitukseen.  Arvioi työpaikkakokemuksesi ja kuinka tärkeä se on kullekin lausunnolle. Tyytyväisyys perustuu kasvoihin ja tärkeys tähtiin 1-5. ',
      paragraph2: 'Arvioi kokemuksesi tuotteemme käytöstä.',
      title1: 'Satisfaction',
      title2: 'Importance',
    },
  },
  surveyinstruction: {
    surveyinstructionkey: 'Kyselyn ohjeet',
    surveytitle: ' Tällä kyselyllä on',
    twopart: 'Kaksiosainen arviointiprosessi',
    using: 'kunkin lausekkeen osalta käyttäen',
    faces: 'Kasvot',
    and: 'ja',
    star: 'Tähteä.',
    rate: 'Arvioi kuinka paljon sinä',
    agree: 'samaa tai eri mieltä',
    statement: 'jokaisen lauseen kanssa käyttämällä',
    then: 'sitten',
    how: 'kuinka',
    important: 'tärkeä',
    eachstatement: 'Jokainen lausunto on sinulle työpaikalla käyttämällä',
    starrating: '5 tähden luokitus',
    scale: 'mittakaava.',
  },
  surveyDialogs: {
    title: 'tutkinta',
    addSurvey: {
      descriptionFirstLine:
        'It’s time to make the survey your own. First, select your launch timeline below to get started. You can make changes before the survey opens and extend the survey before it closes. Click',
      link: 'HERE',
      descriptionSecondLine:
        'for best practices to launch and market the survey.',
    },
    editSurvey: {
      description:
        'Need to edit your survey? No problem. You can do that here. Please make your changes below.',
    },
    extendSurvey: { title: 'Extend Survey', closeDate: 'Close Date' },
    confirmClose: {
      title: 'Close Survey',
      actionLabel: 'Close Survey',
      close: 'close',
    },
    confirmDelete: { title: 'Remove Survey', actionLabel: 'Archive Survey' },
    formLabels: {
      surveyName: 'Survey Name',
      launchDate: 'Launch Date',
      closeDate: 'Close Date',
      allowReward: 'Reward survey participation with a Gift Card',
      allowRewardTooltip:
        'Employees will be able to select their gift card directly from our system after they participate',
      allowAnswersToBeUpdated:
        'Give employees permission to edit their survey responses',
      allowAnswersToBeUpdatedTooltip:
        'Edits can only be made when the survey is open',
      rewardAmount: 'Gift Card Amount',
    },
    customizedQuestions: {
      header: 'Add Custom Questions/Statements',
      description:
        'In addition to the 38 questions in our statistically valid #BeHeard engagement survey, you can add up to five 5-star rating questions and five open ended questions. If you want some ideas for your custom questions, check out examples',
      link: 'HERE',
      statement: 'Statement',
      statementPlaceholder: 'Type your question/statement...',
      fiveStarQuestions: { header: '5-Star Rating Questions' },
      openEndedQuestions: { header: 'Open-Ended Questions' },
    },
  },
  surveyLanding: {
    welcomeToSparck: 'Tervetuloa Sparck!',
    areYouReady: 'Oletko valmis {beheard}?',
    thankYou: 'Kiitos, että annoit äänesi kuulua.',
    noActiveSurveys:
      "There is no active survey to complete right now, but we're glad you checked in.",
    whatBeHeardSurveyIs:
      '#BeHeard Survey on anonyymi kysely, joka on suunniteltu turvalliseksi paikaksi jakaa palautetta työpaikasta. Organisaatiosi välittää mielipiteestäsi ja haluaa antaa sinulle luottamuksellisen äänen puhuaksesi vapaasti, siksi se teki yhteistyötä Sparckin kanssa! Vain kootut tulokset jaetaan lopussa, jotta organisaation strategiat etenevät eteenpäin niiden alueiden perusteella, jotka merkitsevät eniten sinulle ja kollegoillesi.',
    youAreAwesome:
      'Olet mahtava! Kiitos, että käytit aikaa #BeHeardiin. Palautteesi on korvaamaton.',
    feedbackImportance:
      "Your feedback is really important to us, so we'll send you an email as soon as a new survey is posted!",
    eachItemExplanation:
      'Kyselyyn vastaaminen vie vain noin 10 minuuttia. Jokaisessa kohdassa on kaksi osaa: ensinnäkin arvioit, missä määrin olet samaa tai eri mieltä kunkin työpaikkalausekkeen kanssa valitsemalla yksi kasvoista. Kun olet tehnyt sen, voit arvioida, kuinka tärkeä kukin lausunto on sinulle tähtien avulla. Katso animoitu esimerkki!',
    iAmReady: 'Olen valmis vastaamaan kyselyyn!',
    updateMyAnswers: 'Review my answers!',
    surveyPagination: { previous: 'Edellinen', nextPage: 'Seuraava sivu' },
    submitSurvey: 'Lähetä kysely',
    pendingGiftCards: 'You have {count} pending Gift Cards! 🎉',
    pendingGiftCardLabel: '{rewardValue} for {surveyName}',
    redeem: 'Redeem',
    giftCardRedeemed: 'Gift Card redeemed successfully!',
    departmentTerm: 'Osasto',
    departmentValue: ' ',
    missionAndValueTerm: 'Missio ja arvot',
    missionAndValueText:
      'Rakennamme jotain erityistä, joka keskittyy asiakkaidemme parhaiden tulosten saavuttamiseen älykkään integraation ja automaation avulla',
    missionAndValueValue: 'Arvot: Ole rohkea. Ole itsesi. Ole Boomi.',
    managerTerm: 'Esimies',
    managerValue: 'Suora johtajasi 8.6.2023.',
    seniorLeadershipTeamTerm: 'Ylin johtoryhmä',
    seniorLeadershipTeamValue: 'Johtoryhmä',
    surveyInstructionsTitle: 'Survey Instructions',
    surveyInstructionsContent:
      'This survey has a two-part rating process for each statement using Faces  and Stars.  Rate how much you agree or disagree with each statement using the faces and then how important each statement is to you in the workplace using a 5-star rating scale.',
    boomiSurveyLandingContent:
      '#BeHeard-kysely on anonyymi kysely, joka on suunniteltu turvalliseksi paikaksi antaa palautetta kokemuksestasi Boomilla.  Boomi välittää mielipiteistäsi ja haluaa antaa sinulle luottamuksellisen keinon puhua vapaasti. Tämän vuoksi se tekee kyselyn yhteistyössä Sparckin kanssa. Kyselyn jälkeen jaetaan ainoastaan yhdistetyt tulokset. Niiden avulla voidaan auttaa muokkaamaan organisaation strategioita alueilla, jotka ovat sinulle ja kollegoillesi tärkeimpiä Boomilla. Ennen kuin aloitat, tässä on muutamia määritelmiä, jotta me kaikki ymmärtäisimme ne samalla tavalla:',
    boomiSurveyLandingContentTiming:
      'Kyselyyn vastaamiseen kuluu vain noin 15 minuuttia. Jokaisessa kysymyksessä on kaksi osaa: Ensin arvioit, missä määrin olet samaa tai eri mieltä kunkin työpaikkaa koskevan väittämän kanssa, valitsemalla yhden kasvoista. Tämän jälkeen arvioit tähtien avulla, kuinka tärkeä kukin väittämä on sinulle. Katso animoitu esimerkki!',
    topicCards: {
      secure: {
        title: 'Tietosi ovat {avainsana}',
        avainsana: 'Suojattu',
        description:
          'Suhtaudumme tietosuojaan erittäin vakavasti.Sparck käyttää joukkoa teknologioita ja protokollia, jotka estävät tietovuodot ja kyberhyökkäykset',
      },
      anonymous: {
        title: 'Osallistuminen on {avainsana}',
        avainsana: 'Anonymous',
        description:
          'Luottamuksellisuus on meille erittäin tärkeää! Organisaatiosi tai esimiehesi ei koskaan näe yksittäisiä vastauksiasi. Antamamme tiedot ovat täysin anonyymejä.',
      },
      giftCard: {
        title: 'This Survey Has a {keyword}!',
        keyword: 'Gift Card',
        description:
          'That’s right! As a “Thank You” for completing the survey, your organization is treating you to a giftcard of your choice. You can redeem it at the end. Enjoy!',
      },
      answersUpdate: {
        title: '{keyword} Your Answers',
        keyword: 'Update',
        description:
          'Great news! You can come back to update and edit your answers at any point while the survey is still open. Just log back in!',
      },
    },
  },
  surveyOverview: {
    snackbarSuccess: {
      openSurvey: 'The survey is now open!',
      extendedSurvey: 'The survey close date has been extended successfully!',
      closedSurvey: 'The survey has been closed!',
      deletedSurvey: 'The survey has been archived!',
      employeesInvited: 'Employees have been invited successfully!',
      employeesRemoved: 'Employees removed successfully!',
      addedToCart: 'Survey added to your cart successfully',
      randomParticipationsCreated:
        'Random participation completion queued successfully!',
      randomParticipationsJob:
        'Background job submitted (ID: {jobId}).',
    },
    selectLabel: 'Survey',
    minimumNumberOfEmployees:
      'Your organization must have at least 5 employees to create a new survey.',
    whenSurveyCloses:
      'When your survey closes the #BeHeard results will be immediately available.',
    scheduledLaunchSurveyInfo:
      "Your survey isn't live yet.  It will Launch Automatically on {launchDate}. If you would like to launch it manually you can click the Launch Survey button or edit your survey to Launch Manually.",
    manualLaunchSurveyInfo:
      "Your survey isn't live yet and it is set to Launch Manually. When you are ready to launch your survey, click the Launch Survey button.",
    newSurvey: 'New Survey',
    launchSurvey: 'Launch Survey',
    editSurvey: 'Edit Survey',
    extendSurvey: 'Extend Survey',
    closeSurvey: 'Close Survey',
    createRandomParticipations: 'Create Random Participations',
    applyUpgrade: 'Apply Upgrade',
    printSurvey: 'Print',
    applyDowngrade: 'Apply Downgrade',
    inviteEmployees: 'Invite Employees',
    deleteSurvey: 'Archive Survey',
    createRandomParticipationsDescription:
      'This will automatically create random participations for the selected survey. Please confirm the survey information and enter the required details to continue.',
    createRandomParticipationsCompany:
      'Company: {name} ({id})',
    createRandomParticipationsSurvey: 'Survey: {name} ({id})',
    createRandomParticipationsCountLabel: 'Participations to create',
    createRandomParticipationsCountHelper:
      'Enter a number between 1 and {max}.',
    createRandomParticipationsSecurityLabel:
      'Security pass (company_id + survey_id)',
    createRandomParticipationsSecurityHelper:
      'Type {pass} to confirm this action.',
    createRandomParticipationsSecurityMissing:
      'Unable to validate the security pass. Company or survey information is missing.',
    createRandomParticipationsAction: 'Create Participations',
    createRandomParticipationsCompanyLabel: 'Company',
    createRandomParticipationsCompanyId: 'ID: {id}',
    createRandomParticipationsSurveyLabel: 'Survey',
    createRandomParticipationsSurveyId: 'ID: {id}',
    anticipatedTurnover: 'Anticipated Turnover more than 12 Months Away',
    overallParticipation: 'Overall Participation Rate',
    person: 'Person',
    people: 'People',
    removeEmployees: 'Remove Employees',
    employeesInvitation: {
      inviteEmployees: 'Invite Employees',
      chooseEmployees: 'Choose below the employees you want to invite for',
      textFieldLabel: 'Choose one or more employees',
      cancelButton: 'Cancel',
      inviteButton: 'Invite Employees',
    },
    employeesRemoval: {
      removeEmployees: 'Remove Employees',
      description: 'Choose the employees you want to remove from {surveyName}.',
      warning:
        'Removing employees deletes their answers and reward intentions for this survey.',
      confirmMessage:
        'Are you sure you want to remove {count} employee(s) from {surveyName}?',
      confirmButton: 'Remove Employees',
      textFieldLabel: 'Choose one or more employees',
      cancelButton: 'Cancel',
      removeButton: 'Remove Employees',
    },
    tabs: { labels: { general: 'General', sharedReports: 'Shared Reports' } },
    validations: {
      surveyNameIsRequired: 'Survey Name is required',
      minimumLaunchDate: 'You cannot select a past date',
      maximumLaunchDate: 'Launch Date cannot be after the Close Date',
      launchDateIsRequired: 'Launch Date is required',
      minimumCloseDate: 'Close Date cannot be before Launch Date',
      closeDateIsRequired: 'Close Date is required',
      rewardAmountIsRequired: 'Gift Card amount is required',
    },
  },
  surveyProgress: {
    bulletLabels: {
      createdOn: 'Created on',
      openOn: 'Open on',
      closedOn: 'Closed on',
      willCloseOn: 'Will Close on',
    },
  },
  ratingSection: {
    toWhatExtent:
      'Missä määrin olet samaa tai eri mieltä tämän väitteen kanssa?',
    important: 'Tämä on minulle tärkeää',
    ratingLabels: {
      stronglyDisagree: 'Täysin eri mieltä',
      disagree: 'eri mieltä',
      neutral: 'Neutraali',
      agree: 'Olla samaa mieltä',
      stronglyAgree: 'Vahvasti samaa mieltä',
      notApplicable: 'Ei sovellettavissa',
    },
    change: 'Muuttaa',
    unansweredItem: 'Please respond to every item before continuing.',
    formLabels: {
      textField: 'Your answer',
      placeholder: 'Type anything you want here...',
      helperText:
        'To ensure your confidentiality, do not put any personally identifiable information.',
    },
  },
  manageShareReport: {
    reportSections: {
      labels: {
        comparisonGraph: 'Comparison Graph',
        results: 'Results',
        topFiveActionAreas: 'Top 5 Action Areas',
        topFiveStrengths: 'Top 5 Strengths',
        topFiveMostImportantItems: 'Top 5 Most Important Items',
        recommendations: 'Recommendations',
        turnoverForecast: 'Employee turnover forecast',
        fullReport: 'Full Report',
        customRatingQuestions: 'Custom Ratings Questions',
        customOpenEndedQuestions: 'Custom Open-Ended Questions',
      },
    },
    previewFor: 'Preview for {name}',
    reportWillBeSharedWithRoles: 'This report will be shared with',
    formHandler: {
      title: 'Share Report',
      labels: {
        name: 'Shared Report Name',
        expirationDate: 'How long is it available?',
        whatToSee: 'What can they see?',
        limitReport: 'Limit Report by Demographics',
        whichRoles: 'Which Roles can see this Share Report?',
        roles: 'Roles',
        whichDemographics: 'Which Demographics will receive this Share Report?',
      },
      placeholders: { beheardReport: '#BeHeard ShareReport 001' },
      dialog: {
        title: 'Warning!',
        content: {
          firstLine:
            "Are you sure you want to give access to your employee's answers?",
          secondLine:
            'The answers contain very sensitive information. Please be absolutely sure that you selected the correct demographics for this action.',
        },
        buttonText: 'I understood!',
      },
    },
    snackbars: { invitesSent: 'Invites sent successfully' },
  },
  inviteShareReport: {
    dialogTitle: 'Invite for Share Report',
    dialogActionLabel: 'Share this report',
    clickToInvite:
      'Your Shared Report was created but you need to invite. Click "Share this report" to send e-mails to your invitees',
  },
  shareReport: {
    title: 'Share Reports',
    description: 'You control who has access to your #BeHeard Premium Reports',
    columnHeaders: {
      sharedReport: 'Shared Report Name',
      surveyName: 'Survey Name',
      expires: 'Expires',
    },
    validations: {
      minimumExpirationDate: 'You cannot select a past date',
      expirationDateIsRequired: 'Expiration Date is required',
    },
  },
}


